import React from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
const NavbarMenu = () => {
  return (
    <div>
<Navbar collapseOnSelect expand="lg">
  <Container>
    <Nav className="ms-auto">
    </Nav>

  </Container>
</Navbar>
    </div>
  )
}

export default NavbarMenu